<template>
  <v-text-field
    v-model="siteIdInput"
    label="Site ID"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('siteId', input)"
  />
  <v-text-field
    v-model="waiterIdInput"
    label="Waiter ID"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('waiterId', input)"
  />
  <v-text-field
    v-model="hashInput"
    label="Hash"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('authentication', input, 'hash')"
  />
  <v-text-field
    v-model="redactedTokenInput"
    label="RedactedToken"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('authentication', input, 'redactedToken')"
  />
  <v-text-field
    v-model="saltInput"
    label="Salt"
    outlined
    dense
    clearable
    @update:model-value="(input) => updateConfig('authentication', input, 'salt')"
  />
</template>

<script setup lang="ts">
import { CPullNCRIntegrationConfig } from "@tableyeti/merchant-service/api.ts";
import { ref, watch } from "vue";

const { pullIntegrationConfig } = defineProps<{
  pullIntegrationConfig?: CPullNCRIntegrationConfig | undefined;
}>();
const emit = defineEmits(["update:pullIntegrationConfig"]);

const siteIdInput = ref<string | undefined>(pullIntegrationConfig?.siteId);
const waiterIdInput = ref<string | undefined>(pullIntegrationConfig?.waiterId);
const hashInput = ref<string | undefined>(pullIntegrationConfig?.authentication?.hash);
const redactedTokenInput = ref<string | undefined>(
  pullIntegrationConfig?.authentication?.redactedToken,
);
const saltInput = ref<string | undefined>(pullIntegrationConfig?.authentication?.salt);

const updateConfig = (key: keyof CPullNCRIntegrationConfig, value: string, subKey?: string) => {
  if (subKey) {
    emit("update:pullIntegrationConfig", {
      ...pullIntegrationConfig,
      [key]: {
        // @ts-expect-error: this can become more than just authentication and TS is not smart enough
        ...(pullIntegrationConfig?.[key] || {}),
        [subKey]: value,
      },
    });
  } else {
    emit("update:pullIntegrationConfig", { ...pullIntegrationConfig, [key]: value });
  }
};

watch(
  () => pullIntegrationConfig,
  (newConfig) => {
    siteIdInput.value = newConfig?.siteId;
    waiterIdInput.value = newConfig?.waiterId;
    hashInput.value = newConfig?.authentication?.hash;
    redactedTokenInput.value = newConfig?.authentication?.redactedToken;
    saltInput.value = newConfig?.authentication?.salt;
  },
  { deep: true },
);
</script>
